"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsDAOExecutorV2__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "txHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "target",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "signature",
                type: "string",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "CancelTransaction",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "erc20Token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "ERC20Sent",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "ETHSent",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "txHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "target",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "signature",
                type: "string",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "ExecuteTransaction",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "NewAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "newDelay",
                type: "uint256",
            },
        ],
        name: "NewDelay",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "NewPendingAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "txHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "target",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "signature",
                type: "string",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "QueueTransaction",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        inputs: [],
        name: "GRACE_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAXIMUM_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MINIMUM_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "NAME",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "acceptAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "signature",
                type: "string",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "cancelTransaction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "delay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "signature",
                type: "string",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "executeTransaction",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "admin_",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "delay_",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "signature",
                type: "string",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "queueTransaction",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "queuedTransactions",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "address",
                name: "erc20Token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokensToSend",
                type: "uint256",
            },
        ],
        name: "sendERC20",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "ethToSend",
                type: "uint256",
            },
        ],
        name: "sendETH",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "delay_",
                type: "uint256",
            },
        ],
        name: "setDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "pendingAdmin_",
                type: "address",
            },
        ],
        name: "setPendingAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NounsDAOExecutorV2__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsDAOExecutorV2__factory = NounsDAOExecutorV2__factory;
NounsDAOExecutorV2__factory.bytecode = _bytecode;
NounsDAOExecutorV2__factory.abi = _abi;
